"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsDAOExecutorV2__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "txHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "target",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "signature",
                type: "string",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "CancelTransaction",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "erc20Token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "ERC20Sent",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "ETHSent",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "txHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "target",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "signature",
                type: "string",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "ExecuteTransaction",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "NewAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "newDelay",
                type: "uint256",
            },
        ],
        name: "NewDelay",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "NewPendingAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "txHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "target",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "signature",
                type: "string",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "QueueTransaction",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        inputs: [],
        name: "GRACE_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAXIMUM_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MINIMUM_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "NAME",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "acceptAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "signature",
                type: "string",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "cancelTransaction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "delay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "signature",
                type: "string",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "executeTransaction",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "admin_",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "delay_",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "signature",
                type: "string",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "queueTransaction",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "queuedTransactions",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "address",
                name: "erc20Token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokensToSend",
                type: "uint256",
            },
        ],
        name: "sendERC20",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "ethToSend",
                type: "uint256",
            },
        ],
        name: "sendETH",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "delay_",
                type: "uint256",
            },
        ],
        name: "setDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "pendingAdmin_",
                type: "address",
            },
        ],
        name: "setPendingAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NounsDAOExecutorV2__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsDAOExecutorV2__factory = NounsDAOExecutorV2__factory;
NounsDAOExecutorV2__factory.bytecode = _bytecode;
NounsDAOExecutorV2__factory.abi = _abi;
